import moment from 'moment'
import { app } from '@/main'
import { SET_CURRENT_SLIDE_MODE } from '@/vuex/types'

// mutations
import common from '@/vuex/mutations/common'
import currentUser from '@/vuex/mutations/currentUser'
import currentAccount from '@/vuex/mutations/currentAccount'
import errors from '@/vuex/mutations/errors'
import folders from '@/vuex/mutations/folders'
import numbers from '@/vuex/mutations/numbers'
import indicators from '@/vuex/mutations/indicators'
import presentations from '@/vuex/mutations/presentations'
import selections from '@/vuex/mutations/selections'
import syncLoading from '@/vuex/mutations/syncLoading'
import slideActive from '@/vuex/mutations/slideActive'
import presentation from '@/vuex/mutations/presentation'
import slides from '@/vuex/mutations/slides'
import search from '@/vuex/mutations/search'
import exportData from '@/vuex/mutations/exportData'
import survey from '@/vuex/mutations/survey'
import breadcrumbs from '@/vuex/mutations/breadcrumbs'
import socketMutations from '@/vuex/mutations/socket'
import pricingMutations from '@/vuex/mutations/pricing'
import clickedUrl from '@/vuex/mutations/clickedUrl'
// import slideOptions from '@/vuex/mutations/slideOptions'
import modal from '@/vuex/mutations/modal'

export default {
  ...common,
  ...currentUser,
  ...currentAccount,
  ...errors,
  ...folders,
  ...numbers,
  ...indicators,
  ...presentations,
  ...selections,
  ...syncLoading,
  ...slideActive,
  ...presentation,
  ...slides,
  ...search,
  ...exportData,
  ...survey,
  ...breadcrumbs,
  ...socketMutations,
  ...pricingMutations,
  ...clickedUrl,
  ...modal,
  // Config multiple language
  setLang: (state, payload) => {
    app.$i18n.locale = payload
    if (payload === 'br') {
      payload = 'pt_BR'
    }
    moment.locale(payload)
  },
  setPresenterLang: (state, payload) => {
    app.$i18nPresenter.locale = payload
    if (payload === 'br') {
      payload = 'pt_BR'
    }
    state.presenterLocale = payload
  },

  // update sync presentation
  setSyncPresentation: (state, payload) => {
    // 1. spinning
    // 2. saved
    // 3. error

    if (state.isSyncing > 2) {
      return
    }

    state.isSyncing = payload
  },

  [SET_CURRENT_SLIDE_MODE]: (state, payload) => {
    state.currentSlideMode = payload
  },

  SET_ROUTE: (state, route) => {
    state.route = route
  },
}
